const ITEMS = [
    "2026 RAV4",
    "Allocation guaranteed",
    "Below sticker — fee included",
    "Members first",
    "One-time $399",
    "90 days or full refund",
];

const Row = () => (
    <div className="flex shrink-0 items-center">
        {ITEMS.map((item) => (
            <span key={item} className="flex items-center">
                <span className="px-8 font-display text-2xl font-bold uppercase tracking-tight text-zinc-600 sm:text-3xl">
                    {item}
                </span>
                <span className="h-2 w-2 rotate-45 bg-[#2563EB]/70" aria-hidden="true" />
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <div
        data-testid="editorial-marquee"
        aria-hidden="true"
        className="overflow-hidden border-y border-white/10 bg-[#080808] py-8"
    >
        <div className="animate-marquee flex w-max">
            <Row />
            <Row />
        </div>
    </div>
);
